import { Images } from "@/constants/images"
import { Box, Collapse, Flex, MantineTheme, Text, createStyles } from "@mantine/core"
import { useDisclosure, useMediaQuery } from "@mantine/hooks"
import Image from "next/image"
import { FC } from "react"

const useStyles = createStyles((theme: MantineTheme, { opened }: { opened: boolean }) => ({
  box: {
    cursor: "pointer",
    minHeight: 71,
    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
    borderBottom: !opened ? "1px solid rgba(0, 0, 0, 0.1)" : "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: 11,
    [theme.fn.smallerThan("sm")]: {
      paddingRight: 0,
    },
  },
}))

export const CollapseOverWrite: FC<{ title: string; description: string }> = ({ title, description }) => {
  const [opened, { toggle }] = useDisclosure(false)
  const { classes } = useStyles({ opened })

  const isResponsive = useMediaQuery("(max-width: 48em)")

  return (
    <Flex p={0} m={0} w={"100%"} direction={"column"}>
      <Box className={classes.box} onClick={toggle}>
        <Text fz={isResponsive ? 12 : 16} fw={400} color="#393939">
          {title}
        </Text>
        <Image src={Images.downThin} alt="down-thin" />
      </Box>
      <Collapse in={opened}>
        <Box>
          <Text fz={isResponsive ? 12 : 14} fw={400} color="#393939" mb={20} italic>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </Text>
        </Box>
      </Collapse>
    </Flex>
  )
}
